import { ApiResponse } from "../context/VolunteersHighlightContext/constants";
import {
	UpdateVolunteersFAQRequest,
	VolunteersFAQFormData,
	VolunteersFAQGetApiResponse,
	VolunteersFAQListApiResponse,
} from "../context/VolunteersFAQContext/constants";
import { axiosInstance } from "../utils/axiosInstance";

const ENDPOINTS = {
	VOLUNTEERS_FAQ: "/cms/volunteers-faq",
};

const trimText = (value?: string) => (value === undefined ? undefined : value.trim());

export const buildAddVolunteersFAQRequest = (data: VolunteersFAQFormData) => ({
	isActive: data.isActive,
	...(data.displayOrder === undefined ? {} : { displayOrder: data.displayOrder }),
	volunteersFAQLocalizable: data.volunteersFAQLocalizable.map(item => ({
		culture: item.culture,
		question: item.question.trim(),
		answer: item.answer.trim(),
	})),
});

// Only the changed fields are sent; a cleared display order (null) is left out because the validator stops it first.
export const buildUpdateVolunteersFAQRequest = (request: UpdateVolunteersFAQRequest) => ({
	faqId: request.faqId,
	...(request.isActive === undefined ? {} : { isActive: request.isActive }),
	...(typeof request.displayOrder === "number" ? { displayOrder: request.displayOrder } : {}),
	...(request.volunteersFAQLocalizable
		? {
			volunteersFAQLocalizable: request.volunteersFAQLocalizable.map(item => ({
				...item,
				question: trimText(item.question),
				answer: trimText(item.answer),
			})),
		}
		: {}),
});

export class VolunteersFAQService {
	static async getVolunteersFAQList(): Promise<VolunteersFAQListApiResponse> {
		const response = await axiosInstance.get(ENDPOINTS.VOLUNTEERS_FAQ);
		return response.data;
	}

	static async getVolunteersFAQDetails(faqId: string): Promise<VolunteersFAQGetApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.VOLUNTEERS_FAQ}/${faqId}`);
		return response.data;
	}

	static async addVolunteersFAQ(data: VolunteersFAQFormData): Promise<ApiResponse<unknown>> {
		const response = await axiosInstance.post(ENDPOINTS.VOLUNTEERS_FAQ, buildAddVolunteersFAQRequest(data));
		return response.data;
	}

	static async updateVolunteersFAQ(request: UpdateVolunteersFAQRequest): Promise<ApiResponse<unknown>> {
		const response = await axiosInstance.patch(ENDPOINTS.VOLUNTEERS_FAQ, buildUpdateVolunteersFAQRequest(request));
		return response.data;
	}

	static async removeVolunteersFAQ(faqId: string): Promise<ApiResponse<unknown>> {
		const response = await axiosInstance.delete(`${ENDPOINTS.VOLUNTEERS_FAQ}/${faqId}`);

		if (response.status === 204) {
			return { result: null, error: null, isSuccessful: true };
		}

		return response.data;
	}
}
